import styled from "styled-components";

export default styled.div`
  background-color: var(--color-darkblue);
  height: 100vh;
  max-height: 100vh;
  color: var(--color-grey);
  padding: 3.2rem 2.4rem;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;
